/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { PbItemComponentFinderView, PriceBookRestService } from '@gh/builder-shared-data';
import { FinderDialogConfig } from '@gh/common-internal-shared';
import { DictionaryService, InitDialogViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { DialogRouteSnapshot } from '@gh/core-ui';
import { map$ } from '@gh/rx/operators';
import { pbFinderCcFromDto } from './pb-component-item-finder.model';

export interface PbComponentItemFinderDialogConfig extends FinderDialogConfig {
  priceBookId: ID;
  priceBookName: string;
  housePlanId?: ID;
  housePlanName?: string;
  jobId?: ID;
  jobNumber?: string;
  isNumericSelector?: boolean;
}

@Injectable()
export class PbComponentItemFinderBusinessService implements InitDialogViewService<PbComponentItemFinderDialogConfig> {
  constructor(private priceBookRest: PriceBookRestService,
              private dictionaryService: DictionaryService) {

  }

  initDialogView(snapshot: DialogRouteSnapshot<PbComponentItemFinderDialogConfig>): any {
    const { priceBookId, housePlanId, jobId } = snapshot.input;

    return {
      views: this.dictionaryService.getByEnum(PbItemComponentFinderView),
      hierarchy: this.priceBookRest.findRelatedCalculatedHierarchy(priceBookId, { housePlanId, jobId }).pipe(
        map$((costCenters) => costCenters.map(pbFinderCcFromDto))),
    };
  }
}
